export default __webpack_public_path__ + "static/media/information--gas-station--g2.397a57fc.png";